import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_pairingSetIdAdapter204jlhkjchobz as get_pairingSetIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { KotlinInstantAdapter_instancedmy0d2wf294o as KotlinInstantAdapter_instance } from '../../../../../../../../apollo-kotlin-adapters-apollo-adapters-core/com/apollographql/adapter/core/KotlinInstantAdapter.mjs';
import { PinnedPairInput_InputAdapter_instance4omij0810htl as PinnedPairInput_InputAdapter_instance } from './PinnedPairInput_InputAdapter.mjs';
import {
  obj2vqjd1bjrpmyg as obj,
  list2lpjhmv1d2k19 as list,
  get_NullableStringAdapter3fffxc67fmluc as get_NullableStringAdapter,
  presentmhd0a0ip21um as present,
} from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Present1shu3953j96zb as Present } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePairAssignmentsInput3tgrc8c2zd524 as SavePairAssignmentsInput } from '../SavePairAssignmentsInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePairAssignmentsInput_InputAdapterClass;
function SavePairAssignmentsInput_InputAdapter() {
  if (SavePairAssignmentsInput_InputAdapterClass === VOID) {
    class $ {
      s41(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      n75(writer, customScalarAdapters, value) {
        writer.k4e('partyId');
        get_partyIdAdapter().t41(writer, customScalarAdapters, value.k73_1);
        writer.k4e('pairingSetId');
        get_pairingSetIdAdapter().t41(writer, customScalarAdapters, value.l73_1);
        writer.k4e('date');
        KotlinInstantAdapter_instance.s4i(writer, customScalarAdapters, value.m73_1);
        writer.k4e('pairs');
        list(obj(PinnedPairInput_InputAdapter_instance)).p42(writer, customScalarAdapters, value.n73_1);
        var tmp = value.o73_1;
        if (tmp instanceof Present()) {
          writer.k4e('discordMessageId');
          present(get_NullableStringAdapter()).r42(writer, customScalarAdapters, value.o73_1);
        }
        var tmp_0 = value.p73_1;
        if (tmp_0 instanceof Present()) {
          writer.k4e('slackMessageId');
          present(get_NullableStringAdapter()).r42(writer, customScalarAdapters, value.p73_1);
        }
      }
      t41(writer, customScalarAdapters, value) {
        return this.n75(writer, customScalarAdapters, value instanceof SavePairAssignmentsInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePairAssignmentsInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePairAssignmentsInput_InputAdapterClass = $;
  }
  return SavePairAssignmentsInput_InputAdapterClass;
}
var SavePairAssignmentsInput_InputAdapter_instance;
function SavePairAssignmentsInput_InputAdapter_getInstance() {
  return SavePairAssignmentsInput_InputAdapter_instance;
}
//region block: init
SavePairAssignmentsInput_InputAdapter_instance = new (SavePairAssignmentsInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePairAssignmentsInput_InputAdapter_instance as SavePairAssignmentsInput_InputAdapter_instance1ijpf5vgr3aq3,
};
//endregion

//# sourceMappingURL=SavePairAssignmentsInput_InputAdapter.mjs.map
